// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

customerCardStyles.addressGridItem = {
    width: 7,
};
customerCardStyles.actionsGridItem = {
    width: 5,
    css: css`
        justify-content: flex-end;
    `
};
customerCardStyles.selectButton = { variant: "primary" };
customerCardStyles.editLink = {
    css: css`
        margin-top: 12px;

        ${TypographyStyle} {
            font-size: 12px;
            line-height: 14px;
        }
    `,
};
